/* eslint-disable react/jsx-no-target-blank */
// IMPORTANT: Any changes to sidebar menu items must also be reflected in
// src/app/routing/PrivateRoutes.js (add/remove corresponding routes).
import React, {useContext} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from "./SidebarMenuItemWithSub";
import {useAuth} from "../../../../../app/modules/auth";
import {isSuperAdmin} from "../../../../../app/utils/Utils";
import TrackVASContext from "../../../../../app/TrackVASContext";

// Icons
// Font Icons - https://preview.keenthemes.com/metronic-v4/theme/admin_4/ui_icons.html
// SideBar Icons - https://preview.keenthemes.com/html/metronic/docs/icons/keenicons

const SidebarMenuMain = () => {
    const myData = useContext(TrackVASContext);

    const intl = useIntl();
    const {currentUser} = useAuth();

    return (
        <>
            {isSuperAdmin(currentUser) === false &&
            <>

                <SidebarMenuItem to='/dashboard' icon='element-11' title='Dashboard' fontIcon='bi-app-indicator'/>
                <SidebarMenuItem to='/activeJobs' icon='notepad' title='Active Jobs'/>
                <SidebarMenuItem to='/jobCards' icon='document' title='Job Cards'/>
                <SidebarMenuItem to='/waterWash' icon='rocket' title='Water Wash' fontIcon='bi-droplet'/>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Attendance'
                    icon='calendar-tick'>
                    <SidebarMenuItem to='/attendance/branches' icon='calendar-tick' title='Mark Attendance'/>
                    <SidebarMenuItem to='/attendance/month-view' icon='eye' title='View Attendance'/>
                </SidebarMenuItemWithSub>

                {/* Reports */}
                <div className='menu-item'>
                    <div className='menu-content pt-8 pb-2'>
                        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reports</span>
                    </div>
                </div>

                <SidebarMenuItem to='/reports' icon='chart-simple' title='All Reports' fontIcon='bi-bar-chart'/>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Treatment Reports'
                    icon='flask'>
                    <SidebarMenuItem to='/reports/treatments-by-advisor' icon='user' title='By Advisor'/>
                    <SidebarMenuItem to='/reports/treatments-by-supervisor' icon='user-tick' title='By Supervisor'/>
                    <SidebarMenuItem to='/reports/treatments-by-branch' icon='home-2' title='By Branch'/>
                    <SidebarMenuItem to='/reports/treatments-by-dealer' icon='shop' title='By Dealer'/>
                    <SidebarMenuItem to='/reports/most-used-treatments' icon='star' title='Most Used'/>
                </SidebarMenuItemWithSub>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Operations Reports'
                    icon='graph-up'>
                    <SidebarMenuItem to='/reports/treatment-category-analysis' icon='category' title='Category Analysis'/>
                    <SidebarMenuItem to='/reports/job-card-summary' icon='document' title='Job Card Summary'/>
                    <SidebarMenuItem to='/reports/advisor-performance' icon='chart' title='Advisor Performance'/>
                    <SidebarMenuItem to='/reports/revenue-analysis' icon='dollar' title='Revenue Analysis'/>
                    <SidebarMenuItem to='/reports/vehicle-segment-analysis' icon='car' title='Vehicle Segment'/>
                    <SidebarMenuItem to='/reports/deleted-treatments' icon='trash' title='Deleted Treatments'/>
                    <SidebarMenuItem to='/reports/daily-job-card-volume' icon='calendar-2' title='Daily Volume'/>
                    <SidebarMenuItem to='/reports/water-wash-analysis' icon='drop' title='Water Wash'/>
                    <SidebarMenuItem to='/reports/vehicle-model' icon='truck' title='Vehicle Model'/>
                    <SidebarMenuItem to='/reports/water-wash-list' icon='drop' title='Water Wash List'/>
                    <SidebarMenuItem to='/reports/treatment-billing' icon='bill' title='Treatment Billing'/>
                    <SidebarMenuItem to='/reports/treatment-monthly-view-dp' icon='calendar-2' title='Monthly View - DP'/>
                    <SidebarMenuItem to='/reports/treatment-monthly-view-cp' icon='calendar-2' title='Monthly View - CP'/>
                </SidebarMenuItemWithSub>


                {/*/!*Finance*!/*/}
                {/*<div className='menu-item'>*/}
                {/*    <div className='menu-content pt-8 pb-2'>*/}
                {/*        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Finance</span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<SidebarMenuItem to='/trackVASBilling' icon='bill' title='TrackVAS Billing'/>*/}

                {/*Admin*/}
                <div className='menu-item'>
                    <div className='menu-content pt-8 pb-2'>
                        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Administration</span>
                    </div>
                </div>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='User Settings'
                    icon='user-tick'>
                    <SidebarMenuItem to='/users' icon='user' title='Users'/>
                    <SidebarMenuItem to='/designations' icon='medal-star' title='Designations'/>
                    <SidebarMenuItem to='/roles' icon='check-circle' title='Roles'/>
                    <SidebarMenuItem to='/permissions' icon='flag' title='Permissions'/>
                </SidebarMenuItemWithSub>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Workers Settings'
                    icon='profile-user'>
                    <SidebarMenuItem to='/workers' icon='people' title='Workers'/>
                    <SidebarMenuItem to='/advisors' icon='user-tick' title='Service Advisors'/>

                </SidebarMenuItemWithSub>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Location Settings'
                    icon='geolocation'>
                    <SidebarMenuItem to='/dealers' icon='shop' title='Dealers'/>
                    <SidebarMenuItem to='/branches' icon='home-2' title='Branches'/>
                    <SidebarMenuItem to='/vehicleModels' icon='truck' title='Vehicle Models'/>
                    <SidebarMenuItem to='/treatments' icon='flask' title='Treatments'/>

                </SidebarMenuItemWithSub>

                <SidebarMenuItem to='/auditLogs' icon='burger-menu-3' title='Audit Logs'/>
            </>
            }

            {isSuperAdmin(currentUser) &&
            <>
                {/*Super Admin*/}
                <div className='menu-item'>
                    <div className='menu-content pt-8 pb-2'>
                        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Super Admin</span>
                    </div>
                </div>
                <SidebarMenuItem to='/sadashboard' icon='element-11' title='Dashboard'/>
                <SidebarMenuItem to='/organizations' icon='home' title='Organizations'/>

                <SidebarMenuItemWithSub
                    to='/crafted/pages'
                    title='Billing'
                    icon='bill'
                    fontIcon='bi-credit-card'>
                    <SidebarMenuItem to='/super-admin/billing/monthly' icon='calendar-2' title='Monthly Overview'/>
                    <SidebarMenuItem to='/super-admin/billing/config' icon='home' title='Billing Config'/>
                </SidebarMenuItemWithSub>
            </>
            }

            <div className="py-5">
                &nbsp;
            </div>
        </>
    )
};

export {SidebarMenuMain}